import { Section } from '@components/index'
import { SectionTitle } from '@components/section/SectionTitle'
import { DashboardStatistics } from '@services/dashboard/queries/useDashboardStatistics'
import { House } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import { StatTile } from './StatTile'

interface FlatDashboardProps {
  statistics?: DashboardStatistics | undefined
  loading?: boolean
}

const FlatDashboard = ({ statistics, loading }: FlatDashboardProps) => {
  const { t } = useTranslation('dashboard')

  return (
    <Section
      title={<SectionTitle title={t('flatStatus')} icon={<House />} />}
      defaultActiveKey={['0']}
    >
      {loading ? (
        <div className="h-24 animate-pulse rounded-xl bg-ink/[0.04]" />
      ) : (
        <div className="space-y-4">
          <div className="grid gap-5 sm:grid-cols-2">
            <StatTile
              icon={House}
              tone="amber"
              to="/admin/flats?status=RENTED"
              label={t('statistics.rentedFlats')}
              value={statistics?.rented_flats_count ?? 0}
            />
            <StatTile
              icon={House}
              tone="green"
              to="/admin/flats?status=AVAILABLE"
              label={t('statistics.availableFlats')}
              value={statistics?.available_flats_count ?? 0}
            />
          </div>
          <div className="h-px w-full bg-ink/[0.06]" />
          <Link
            to="/admin/flats?status=DRAFT"
            className="inline-flex items-center gap-2 text-sm text-muted-foreground transition-colors hover:text-ink"
          >
            <House className="h-4 w-4" />
            {t('statistics.draftFlats')}:{' '}
            <span className="font-semibold text-ink">
              {statistics?.draft_flats_count ?? 0}
            </span>
          </Link>
        </div>
      )}
    </Section>
  )
}

export default FlatDashboard
